let worker;
let nextId = 0;
const pending = new Map();
function failWorker(error) {
    worker?.terminate();
    worker = undefined;
    for (const solve of pending.values()) {
        clearTimeout(solve.timer);
        solve.reject(error);
    }
    pending.clear();
}
export function disposeBrowserDdWorker() {
    failWorker(new Error('Browser DDS worker disposed'));
}
function getWorker() {
    if (!worker) {
        const target = new Worker(new URL('./dd-browser-worker.js', import.meta.url), { type: 'module' });
        worker = target;
        target.onmessage = ({ data }) => {
            if (worker !== target)
                return;
            const solve = pending.get(data.id);
            if (!solve)
                return;
            pending.delete(data.id);
            clearTimeout(solve.timer);
            if ('error' in data)
                solve.reject(new Error(data.error));
            else
                solve.resolve(data.result);
        };
        target.onerror = (event) => {
            if (worker === target)
                failWorker(new Error(event.message || 'Browser DDS worker failed'));
        };
        target.onmessageerror = () => {
            if (worker === target)
                failWorker(new Error('Unable to decode browser DDS response'));
        };
    }
    return worker;
}
export async function solveInBrowser(request) {
    const target = getWorker();
    const id = nextId++;
    return new Promise((resolve, reject) => {
        // Includes queued solves and initial WASM compilation on slower devices.
        const timer = setTimeout(() => failWorker(new Error('Browser DDS solve timed out')), 60_000);
        pending.set(id, { resolve, reject, timer });
        try {
            target.postMessage({ id, request });
        }
        catch (error) {
            failWorker(error instanceof Error ? error : new Error(String(error)));
        }
    });
}
//# sourceMappingURL=dd-browser.js.map